var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeather(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Temperature_Control",
    "data-name": "Temperature Control"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Flat"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m480 336c0 47.52-40.2 88-88 88-47.45-1.12-87.47-40.13-87.99-87a88.4 88.4 0 0 1 31.99-68.88v-212.12a56 56 0 0 1 112 0v212.12a87.238 87.238 0 0 1 32 67.88z",
    fill: "#f7e0ba"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m448 268.12v-59.068a208.315 208.315 0 0 1 -141.582 106.614 87.4 87.4 0 0 0 -2.408 21.334c.52 46.87 40.54 85.88 87.99 87 47.8 0 88-40.48 88-88a87.238 87.238 0 0 0 -32-67.88z",
    fill: "#f5d59f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160 464a8 8 0 0 1 -8-8v-272a8 8 0 0 1 16 0v272a8 8 0 0 1 -8 8z",
    fill: "#71ad3d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m265.355 343.736c-1.782-.476-43.953-11.537-72.783-1.468-12.109 4.229-24.987 10.955-32.927 20.9-7.941-9.943-20.821-16.669-32.927-20.9-28.832-10.071-71 .992-72.783 1.468a8.005 8.005 0 0 0 -4.363 12.493c42.972 57.977 93.5 59.316 110.073 42.6 17.022 17.171 67.355 15.029 110.073-42.6a8.006 8.006 0 0 0 -4.363-12.493z",
    fill: "#9ccc65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m265.355 263.736c-1.782-.476-43.953-11.537-72.783-1.468-12.109 4.229-24.987 10.955-32.927 20.9-7.941-9.943-20.821-16.669-32.927-20.9-28.832-10.07-71 .993-72.783 1.468a8.005 8.005 0 0 0 -4.363 12.493c1.1 1.48 27.212 36.391 56.044 46.46 17.462 6.1 40.962 9.321 54.029-3.86 17.739 17.895 68.909 12.937 110.073-42.6a8.006 8.006 0 0 0 -4.363-12.493z",
    fill: "#9ccc65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m246.694 195.112c-29.515-6.166-68.175-4.538-88.5 17.55-5.352-6.381-14.408-12.582-28.5-17.5-24.419-8.527-59.509-.863-60.991-.532a8 8 0 0 0 -4.482 12.835c37.249 46.113 78.83 48.2 93.256 36.1 14.373 12.65 56.513 9.355 93.741-35.515a8 8 0 0 0 -4.524-12.938z",
    fill: "#9ccc65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m159.29 448a80.142 80.142 0 0 0 -75.442 53.333h150.883a80.142 80.142 0 0 0 -75.441-53.333z",
    fill: "#f7e0ba"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m159.313 192.005c-11.935 0-24.006-10.484-24.2-33.99-.154-19.039 15.6-40.457 17.4-42.837a8.089 8.089 0 0 1 12.69-.1c1.835 2.351 17.93 23.512 18.083 42.55.133 16.531-6.786 34.223-23.808 34.377z",
    fill: "#9ccc65"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 504,
    fill: "#e8c085",
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280,
    cy: 504,
    fill: "#e8c085",
    r: 8
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#83bd46"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m140 168c-1.355 0-2.693-.071-4.016-.19 2.982 16.644 13.2 24.2 23.329 24.195h.164c17.023-.154 23.941-17.846 23.808-34.377a48.8 48.8 0 0 0 -3.1-15.705 44 44 0 0 1 -40.185 26.077z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m246.694 195.112c-18.525-3.87-40.652-4.666-59.589.737a107.839 107.839 0 0 1 -85.4 44.129c24.44 13.406 46.144 11.652 55.766 3.587 14.373 12.65 56.513 9.355 93.741-35.515a8 8 0 0 0 -4.518-12.938z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m265.355 263.736c-1.708-.457-40.544-10.64-69.152-2.6a108 108 0 0 1 -96.203 58.864c-.289 0-.577-.009-.865-.011a64.753 64.753 0 0 0 6.481 2.7c17.462 6.1 40.962 9.321 54.029-3.86 17.739 17.895 68.909 12.937 110.073-42.6a8.006 8.006 0 0 0 -4.363-12.493z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m265.355 343.736c-1.708-.457-40.544-10.64-69.152-2.6a108 108 0 0 1 -96.203 58.864c-.079 0-.157 0-.235 0 26.4 12.594 49.633 9.169 59.88-1.168 17.022 17.168 67.355 15.026 110.073-42.603a8.006 8.006 0 0 0 -4.363-12.493z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 96,
    cy: 360,
    fill: "#c6ed93",
    r: 16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 368,
    fill: "#c6ed93",
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140,
    cy: 476,
    fill: "#fbf2e2",
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 88,
    cy: 280,
    fill: "#c6ed93",
    r: 16
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 288,
    fill: "#c6ed93",
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m146.977 501.333h87.754a80.119 80.119 0 0 0 -47.124-48.126 87.436 87.436 0 0 1 -40.63 48.126z",
    fill: "#f5d59f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m248 512h-176a8 8 0 0 1 0-16h176a8 8 0 0 1 0 16z",
    fill: "#e8c085"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m392 392a55.9 55.9 0 0 1 -56-55.287c-.327-26.52 17.14-42.765 32-53v-115.713a8 8 0 0 1 8-8h32a8 8 0 0 1 8 8v115.43c16.534 10.585 32 30.055 32 52.57a56.065 56.065 0 0 1 -56 56z",
    fill: "#ea7432"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m448 64v16h-40a8 8 0 0 1 0-16z",
    fill: "#e8c085"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m448 96v16h-56a8 8 0 0 1 0-16z",
    fill: "#e8c085"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m448 128v16h-40a8 8 0 0 1 0-16z",
    fill: "#e8c085"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 392,
    cy: 336,
    fill: "#fa9664",
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344 360c-.88 0-1.757-.013-2.632-.033a55.814 55.814 0 1 0 97.9-53.057 111.923 111.923 0 0 1 -95.268 53.09z",
    fill: "#e2601e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeather);
export default __webpack_public_path__ + "static/media/weather.4a4b2d072d3ec676d975adefdbb68dbb.svg";
export { ForwardRef as ReactComponent };